<app-agricola-navbar></app-agricola-navbar>

<app-agricola-toast
  [message]="toastMessage"
  [type]="toastType"
  [show]="showToast"
  (close)="hideToast()">
</app-agricola-toast>

<div class="detail-page">

  <!-- Top card: back + header + client info + actions -->
  <div class="detail-card top-card">

    <button class="back-btn" (click)="goBack()" type="button">
      <svg viewBox="0 0 20 20" fill="none" aria-hidden="true" class="back-icon">
        <path d="M12 15l-5-5 5-5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      Atras
    </button>

    <div class="policy-header">
      <h1 class="page-title">Detalle de poliza</h1>
      <p class="page-subtitle">{{ basicInfo.productType }}</p>
    </div>

    <div class="client-info">
      <p class="client-info-label">Asegurado/ Tomador</p>
      <p class="client-info-value">
        <strong>Nombre de cliente:</strong> {{ basicInfo.insuredName }}
        <span class="dot" *ngIf="basicInfo.uniqueNumber">•</span>
        <strong *ngIf="basicInfo.uniqueNumber">Número único:</strong> {{ basicInfo.uniqueNumber }}
      </p>
    </div>

    <div class="actions-section" *ngIf="showActions && !isPolicyCancelled">
      <p class="actions-label">¿Qué deseas hacer?</p>

      <div class="info-banner" role="note">
        <div class="info-banner-icon">
          <img src="assets/agricola/toast-idea.svg" alt="" aria-hidden="true">
        </div>
        <div class="info-banner-text">
          <p>Para modificar la información de pago del cliente, te recomendamos utilizar la opción <strong>'Actualizar información de pago'</strong>.</p>
          <p>Si necesitas actualizar varios datos del cliente, puedes utilizar la opción <strong>'Actualizar datos del cliente'</strong>.</p>
          <p>Utiliza la opción <strong>'Solicitar cancelación'</strong> para cancelar la solicitud del cliente</p>
        </div>
      </div>

      <div class="action-buttons">
        <button class="action-btn" type="button" (click)="openUpdatePaymentDialog()">
          <img src="assets/agricola/action-update-payment.svg" alt="" aria-hidden="true">
          Actualizar información de pago
        </button>
        <button class="action-btn" type="button" (click)="openUpdateClientDialog()">
          <img src="assets/agricola/action-update-client.svg" alt="" aria-hidden="true">
          Actualizar datos del cliente
        </button>
        <button class="action-btn" type="button" (click)="openCancelDialog()">
          <img src="assets/agricola/action-cancel.svg" alt="" aria-hidden="true">
          Solicitar cancelación
        </button>
      </div>
    </div>

  </div>

  <!-- Basic info section -->
  <div class="detail-card info-section">
    <h2 class="section-title">Información básica</h2>

    <!-- Datos del cliente -->
    <h3 class="section-subheader">Datos del cliente</h3>
    <div class="fields-grid">
      <div class="display-field">
        <span class="field-label">Nombre</span>
        <span class="field-value">{{ basicInfo.insuredName || '&nbsp;' }}</span>
      </div>
      <div class="display-field">
        <span class="field-label">DUI</span>
        <span class="field-value">{{ basicInfo.dui || '&nbsp;' }}</span>
      </div>
      <div class="display-field">
        <span class="field-label">Fecha de nacimiento</span>
        <span class="field-value">{{ basicInfo.birthday || '&nbsp;' }}</span>
      </div>
      <div class="display-field">
        <span class="field-label">Género</span>
        <span class="field-value">{{ basicInfo.gender || '&nbsp;' }}</span>
      </div>
      <div class="display-field">
        <span class="field-label">Estado civil</span>
        <span class="field-value">{{ basicInfo.relationshipStatus || '&nbsp;' }}</span>
      </div>
      <div class="display-field">
        <span class="field-label">Número tributario</span>
        <span class="field-value">{{ basicInfo.taxNumber || '&nbsp;' }}</span>
      </div>
      <div class="display-field">
        <span class="field-label">Celular</span>
        <span class="field-value">{{ basicInfo.mobile || '&nbsp;' }}</span>
      </div>
      <div class="display-field">
        <span class="field-label">Teléfono</span>
        <span class="field-value">{{ basicInfo.phone || '&nbsp;' }}</span>
      </div>
      <div class="display-field display-field--wide">
        <span class="field-label">Correo electrónico</span>
        <span class="field-value">{{ basicInfo.email || '&nbsp;' }}</span>
      </div>
      <div class="display-field display-field--wide">
        <span class="field-label">Dirección</span>
        <span class="field-value">{{ basicInfo.address || '&nbsp;' }}</span>
      </div>
    </div>

    <!-- Póliza -->
    <h3 class="section-subheader">Datos de la póliza</h3>
    <div class="fields-grid">
      <div class="display-field">
        <span class="field-label">Estado de póliza</span>
        <span class="field-value">{{ basicInfo.policyStatus }}</span>
      </div>
      <div class="display-field">
        <span class="field-label">N° de póliza</span>
        <span class="field-value">{{ basicInfo.policyNumber }}</span>
      </div>
      <div class="display-field">
        <span class="field-label">Fecha de inicio</span>
        <span class="field-value">{{ basicInfo.startDate || '&nbsp;' }}</span>
      </div>
      <div class="display-field display-field--hidden"></div>
      <div class="display-field">
        <span class="field-label">Producto</span>
        <span class="field-value">{{ basicInfo.productType || '&nbsp;' }}</span>
      </div>
      <div class="display-field">
        <span class="field-label">Código de producto</span>
        <span class="field-value">{{ basicInfo.productCode || '&nbsp;' }}</span>
      </div>
      <div class="display-field">
        <span class="field-label">Plan</span>
        <span class="field-value">{{ basicInfo.product || '&nbsp;' }}</span>
      </div>
      <div class="display-field" *ngIf="basicInfo.cancellationReason">
        <span class="field-label">Motivo de cancelación</span>
        <span class="field-value">{{ basicInfo.cancellationReason }}</span>
      </div>
      <div class="display-field" *ngIf="basicInfo.cancellationDate">
        <span class="field-label">Fecha de cancelación</span>
        <span class="field-value">{{ basicInfo.cancellationDate }}</span>
      </div>
    </div>
  </div>

  <!-- Payment info section -->
  <div class="detail-card info-section">
    <h2 class="section-title">Información de pago</h2>
    <div class="fields-grid">
      <div class="display-field">
        <span class="field-label">Cuenta de débito</span>
        <span class="field-value">{{ currentPaymentAccount?.accountNumber || '&nbsp;' }}</span>
      </div>
      <div class="display-field">
        <span class="field-label">Tipo de cuenta</span>
        <span class="field-value">{{ currentPaymentAccount?.accountType || '&nbsp;' }}</span>
      </div>
      <div class="display-field">
        <span class="field-label">Nombre de cuenta</span>
        <span class="field-value">{{ currentPaymentAccount?.accountName || '&nbsp;' }}</span>
      </div>
      <div class="display-field">
        <span class="field-label">Estado de cuenta</span>
        <span class="field-value">{{ currentPaymentAccount?.status || '&nbsp;' }}</span>
      </div>
      <div class="display-field">
        <span class="field-label">Valor prima</span>
        <span class="field-value">{{ basicInfo.insuredAmount || '&nbsp;' }}</span>
      </div>
      <div class="display-field" *ngIf="totalWithAddons != null">
        <span class="field-label">Valor prima con coberturas</span>
        <span class="field-value">$ {{ totalWithAddons }}</span>
      </div>
    </div>
  </div>

  <!-- Addons -->
  <div class="detail-card info-section" *ngIf="addonRows.length > 0">
    <h2 class="section-title">Coberturas adicionales</h2>
    <div class="addons-grid">
      <div class="addon-card" *ngFor="let addon of addonRows">
        <div class="addon-card-header">
          <span class="addon-name">{{ addon.name }}</span>
          <span class="addon-badge" [class.addon-badge--active]="addon.status === 'Activo'" [class.addon-badge--cancelled]="addon.status === 'Cancelado'">{{ addon.status }}</span>
        </div>
        <p class="addon-price">{{ addon.price }}</p>
        <ul class="addon-services" *ngIf="addon.services.length > 0">
          <li *ngFor="let svc of addon.services">{{ svc }}</li>
        </ul>
      </div>
    </div>
    <div class="addons-totals" *ngIf="addonsTotal != null">
      <div class="addons-totals-row">
        <span class="addons-totals-label">Total coberturas adicionales</span>
        <span class="addons-totals-value">$ {{ addonsTotal }}</span>
      </div>
      <div class="addons-totals-row addons-totals-row--main" *ngIf="totalWithAddons != null">
        <span class="addons-totals-label">Total con coberturas</span>
        <span class="addons-totals-value">$ {{ totalWithAddons }}</span>
      </div>
    </div>
  </div>

  <!-- Accounts table -->
  <div class="detail-card info-section" *ngIf="accountRows.length > 0">
    <h2 class="section-title">Cuentas del cliente</h2>
    <div class="table-wrapper">
      <table>
        <thead>
          <tr>
            <th>No. Cuenta</th>
            <th>Tipo de cuenta</th>
            <th>Nombre</th>
            <th>Estado</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of accountRows">
            <td>{{ row.accountNumber }}</td>
            <td>{{ row.accountType }}</td>
            <td>{{ row.accountName }}</td>
            <td>{{ row.status }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- Payment detail table -->
  <div class="detail-card info-section">
    <h2 class="section-title">Detalle de pagos</h2>

    <div class="table-toolbar">
      <div class="pagination-controls">
        <span class="movements-label">{{ paymentMovementsLabel }}</span>

        <button class="page-btn" (click)="goToPaymentPage(paymentCurrentPage - 1)" [disabled]="paymentCurrentPage === 1" aria-label="Página anterior">
          <svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M12 15l-5-5 5-5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </button>
        <button *ngFor="let page of paymentVisiblePages" class="page-btn" [class.page-btn--active]="page === paymentCurrentPage" (click)="goToPaymentPage(page)" [attr.aria-current]="page === paymentCurrentPage ? 'page' : null">{{ page }}</button>
        <button class="page-btn" (click)="goToPaymentPage(paymentCurrentPage + 1)" [disabled]="paymentCurrentPage === paymentTotalPages" aria-label="Página siguiente">
          <svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M8 5l5 5-5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </button>

        <div class="page-size-wrapper">
          <select class="page-size-select" [value]="paymentPageSize" (change)="onPaymentPageSizeChange($event)" aria-label="Registros por página">
            <option *ngFor="let opt of pageSizeOptions" [value]="opt">{{ opt }}</option>
          </select>
          <svg class="select-arrow" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M5 7l5 5 5-5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </div>
      </div>
    </div>

    <div class="table-wrapper">
      <table>
        <thead>
          <tr>
            <th>Fecha de cobro</th>
            <th>Mes</th>
            <th>Monto</th>
            <th>Estado</th>
            <th>Cód. autorización</th>
            <th>Comentario</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of pagedPaymentRows">
            <td>{{ row.chargeDate }}</td>
            <td>{{ row.month }}</td>
            <td>{{ row.total }}</td>
            <td>{{ row.status }}</td>
            <td>{{ row.authorizationCode }}</td>
            <td>{{ row.comment }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- Transaction detail table -->
  <div class="detail-card info-section">
    <h2 class="section-title">Detalle de transacciones</h2>

    <div class="table-toolbar">
      <div class="pagination-controls">
        <span class="movements-label">{{ transactionMovementsLabel }}</span>

        <button class="page-btn" (click)="goToTransactionPage(transactionCurrentPage - 1)" [disabled]="transactionCurrentPage === 1" aria-label="Página anterior">
          <svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M12 15l-5-5 5-5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </button>
        <button *ngFor="let page of transactionVisiblePages" class="page-btn" [class.page-btn--active]="page === transactionCurrentPage" (click)="goToTransactionPage(page)" [attr.aria-current]="page === transactionCurrentPage ? 'page' : null">{{ page }}</button>
        <button class="page-btn" (click)="goToTransactionPage(transactionCurrentPage + 1)" [disabled]="transactionCurrentPage === transactionTotalPages" aria-label="Página siguiente">
          <svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M8 5l5 5-5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </button>

        <div class="page-size-wrapper">
          <select class="page-size-select" [value]="transactionPageSize" (change)="onTransactionPageSizeChange($event)" aria-label="Registros por página">
            <option *ngFor="let opt of pageSizeOptions" [value]="opt">{{ opt }}</option>
          </select>
          <svg class="select-arrow" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M5 7l5 5 5-5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </div>
      </div>
    </div>

    <div class="table-wrapper">
      <table>
        <thead>
          <tr>
            <th>Transacciones</th>
            <th>Fecha de solicitud</th>
            <th>Fecha de proceso</th>
            <th>Monto</th>
            <th>Agencia</th>
            <th>Usuario</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of pagedTransactionRows">
            <td>{{ row.transaction }}</td>
            <td>{{ row.requestDate }}</td>
            <td>{{ row.processDate }}</td>
            <td>{{ row.amount }}</td>
            <td>{{ row.agencyName }}</td>
            <td>{{ row.agencyUser }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

</div>
